export const events = {
  employeePulsePromptIgnored: 'Employee pulse prompt ignored',
  employeePulsePromptSeen: 'Employee pulse prompt seen',
  employeePulseResponseSubmitted: 'Employee pulse response submitted',
}
